import AcceptsInsurance from '../../../common/icons/AcceptsInsurance';
import Experienced from '../../../common/icons/Experienced';
import FitsMySchedule from '../../../common/icons/FitsMySchedule';
import HighRating from '../../../common/icons/HighRating';
import ModernFacilities from '../../../common/icons/ModernFacilities';
import Nearby from '../../../common/icons/Nearby';
import { CostOfAppointment } from '../../../common/icons/CostOfAppointment';

export const options = [
  {
    id: 'high-patient-rating',
    title: 'A high patient rating',
    icon: HighRating,
  },
  {
    // If this tile changes, we must update ScoringModules PreferenceDistanceModule to account for it
    id: 'close-location',
    title: 'A location close by',
    icon: Nearby,
  },
  {
    id: 'modern-spa-like',
    title: 'Modern spa-like practice',
    icon: ModernFacilities,
  },
  {
    id: 'accepts-insurance',
    title: 'Accepts my insurance',
    icon: AcceptsInsurance,
  },
  {
    id: 'fits-schedule',
    title: 'Fits my schedule',
    icon: FitsMySchedule,
  },
  {
    id: 'highly-experienced',
    title: 'Highly experienced dentist',
    icon: Experienced,
  },
  {
    id: 'cost-of-appointment',
    title: 'Cost of appointment',
    icon: CostOfAppointment,
  },
];
